jQuery(document).ready(function($) {
  "use strict";

  $(".widget-tabs").each(function() {
    $(this)
      .find(".widget-menu-tab")
      .children(".item-title")
      .on("click", function() {
        var liActive = $(this).index();
        var contentActive = $(this)
          .siblings()
          .removeClass("active")
          .parents(".widget-tabs")
          .find(".widget-content-tab")
          .children()
          .eq(liActive);
        contentActive.addClass("active").fadeIn("slow");
        contentActive.siblings().removeClass("active");
        $(this)
          .addClass("active")
          .parents(".widget-tabs")
          .find(".widget-content-tab")
          .children()
          .eq(liActive);
      });
  });
});